import { Award, BadgeCheck, CalendarCheck, Eye, LayoutGrid, PackageCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const FEATURES = [
    {
        Icon: BadgeCheck,
        title: "Trusted Professionals",
        text: "Every crew on Reno Genie is vetted, background-checked and reviewed by real homeowners. You get craftspeople who treat your home like their own.",
        span: "md:col-span-4 md:row-span-2",
        big: true,
    },
    {
        Icon: LayoutGrid,
        title: "Multiple Renovation Services",
        text: "Fifteen trades under one roof — no juggling contractors.",
        span: "md:col-span-2",
    },
    {
        Icon: CalendarCheck,
        title: "Simple Booking",
        text: "Pick services, pick a date. Done in minutes.",
        span: "md:col-span-2",
    },
    {
        Icon: Eye,
        title: "Transparent Process",
        text: "Clear scopes, honest pricing, progress you can see.",
        span: "md:col-span-2",
    },
    {
        Icon: Award,
        title: "Quality Work",
        text: "Workmanship standards checked at every milestone.",
        span: "md:col-span-2",
    },
    {
        Icon: PackageCheck,
        title: "End-to-End Convenience",
        text: "Design, build, clean-up and handover — one platform, start to finish.",
        span: "md:col-span-2",
    },
];

export const WhyRenoGenie = () => (
    <section id="why-reno-genie" data-testid="why-reno-genie-section" className="relative bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal className="mb-14">
                <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.24em] text-brand-gold">
                    03 — Why Reno Genie
                </p>
                <h2 className="max-w-2xl font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-brand-deep sm:text-5xl">
                    One Place. <span className="italic text-brand-teal">Every Renovation Need.</span>
                </h2>
            </Reveal>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-6">
                {FEATURES.map((feature, i) => (
                    <Reveal key={feature.title} delay={0.05 * i} className={feature.span}>
                        <div
                            data-testid={`why-card-${i + 1}`}
                            className={`group flex h-full flex-col justify-between rounded-[28px] border border-brand-line bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(6,78,87,0.10)] sm:p-8 ${
                                feature.big ? "bg-brand-surface" : ""
                            }`}
                        >
                            <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-teal text-white transition-all duration-300 group-hover:-rotate-6 group-hover:bg-brand-gold group-hover:text-brand-deep">
                                <feature.Icon className="h-5 w-5" strokeWidth={1.8} />
                            </div>
                            <div>
                                <h3 className={`font-semibold tracking-tight text-brand-deep ${feature.big ? "font-display text-2xl sm:text-3xl" : "text-lg"}`}>
                                    {feature.title}
                                </h3>
                                <p className={`mt-2.5 leading-relaxed text-brand-muted ${feature.big ? "max-w-md text-base" : "text-sm"}`}>
                                    {feature.text}
                                </p>
                                {feature.big && (
                                    <div className="mt-7 flex flex-wrap gap-2.5">
                                        {["Vetted crews", "Background-checked", "Rated 4.9/5"].map((chip) => (
                                            <span
                                                key={chip}
                                                className="rounded-full border border-brand-teal/15 bg-white px-3.5 py-1.5 font-mono text-[11px] font-medium uppercase tracking-[0.14em] text-brand-teal"
                                            >
                                                {chip}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
